import React, {useEffect, useState} from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepLabel";
import StepIcon from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepIcon";
import StepButton from "@material-ui/core/StepButton";
import StepConnector from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepConnector";
import { State } from "../../../../reducers/reducer";
import { useSelector } from "react-redux";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import {hasMarineData, getStepStatusMarine} from "../../../../api/sustainability/allocation/marineUse/data";
import LoadingView from "../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/LoadingView";
import startAllocation from "../../../../api/sustainability/allocationSteps/startAllocation";
import MarineCardEditableTable from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/MarineMainCardTables";
import { useAllocationContainerStyles } from "../../../../common/styles/allocationStyles";

interface Biotemplate {
    id: number;
    biofuel_type: string;
    raw_material_origin: string;
    fuel_type: string;
    raw_material: string;
    double_counted_norway: string;
    reduction_in_climate_emission: number;
    storage_terminal: string;
    available_quantity: number;
    allocated_quantity: number;
    allocated_eq_quantity: number;
}

const MarineContainer: React.FC = () => {
    const classes = useAllocationContainerStyles();

    const isSimulation: any = useSelector((state: State) => state.sustainability.main.isSimulation);
    const periodName: any = useSelector((state: State) => state.sustainability.main.activePeriod);
    const [generalBiotemplates, setGeneralBiotemplates] = useState<Biotemplate[]>([]);
    const [reservedBiotemplates, setReservedBiotemplates] = useState<Biotemplate[]>([]);
    const [stepJointFulfBiotemplates, setStepJointFulfBiotemplates] = useState<Biotemplate[]>([]);
    const [additionalBiotemplates, setAdditionalBiotemplates] = useState<Biotemplate[]>([]);
    const [notApplicableBiotemplates, setNotApplicableBiotemplates] = useState<Biotemplate[]>([]);
    const [generalAllocationNotNeeded, setGeneralAllocationNotNeeded] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [isJointActive, setIsJointActive] = useState(false);
    const [isReqByCustomerActive, setIsReqByCustomerActive] = useState(false);
    const [isOutJointActive, setIsOutJointActive] = useState(false);
    const [isNotApplicableStepActive, setIsNotApplicableStepActive] = useState(false);
    const [isAboveMandateAfterFulfillActive, setIsAboveMandateAfterFulfillActive] = useState(false);
    const [percentageMarineGeneral, setPercentageMarineGeneral] = useState(0);
    const [steps, setSteps] = useState<{[key: string]: any}>({
        1: {
            name: "General Mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        2: {
            name: "Reserved Above the Mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        3: {
            name: "Joint Fulfillment OUT",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: true,
            data: [],
            allocated: {},
        },
        4: {
            name: "Additional Volume Above",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        5: {
            name: "Volumes not Applicable to the Mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        6: {
            name: "Matching",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        7: {
            name: "Customer Requirements",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        8: {
            name: "Draft Report",
            isDirty: false,
            isDisabled: false,
            status: "",
        },
    });
    const updateIsFetching = (value: boolean) => {
        setIsFetching(value);
    };
    const isStepDisabled = (stepNumber: number, stepStatusData?: any) => {
        switch (stepNumber) {
            case 2:
                return !isReqByCustomerActive;
            case 3:
                return !isOutJointActive;
            case 4:
                if (stepStatusData) {
                    const step1Status = stepStatusData[0];
                    return !((step1Status == 2 || step1Status == 3) && stepStatusData[3] != 0);
                }
                return !isAboveMandateAfterFulfillActive;
            case 5:
                return !isNotApplicableStepActive;
            default:
                return false;
        }
    };
    const getStepStatus = async (currentStep?: number) => {
        try {
            const data = await getStepStatusMarine();
            if (data) {
                setSteps(prevSteps => {
                    const updatedSteps = { ...prevSteps };

                    data.step_status.forEach((statusValue: number, index: number) => {
                        const stepKey = index + 1;

                        if (statusValue === 1 && stepKey === 1) {
                            setIsAboveMandateAfterFulfillActive(false);
                        } else if ((statusValue === 2 || statusValue === 3) && stepKey === 1 && data.step_status[3] !== 0) {
                            setIsAboveMandateAfterFulfillActive(true);
                        }

                        let status = null;
                        if (statusValue === 1) {
                            status = "Not Complete";
                        } else if (statusValue === 2) {
                            status = "Complete";
                        } else if (statusValue === 3) {
                            status = "Overallocated";
                        }

                        if (updatedSteps[stepKey]) {
                            updatedSteps[stepKey] = {
                                ...updatedSteps[stepKey],
                                status,
                            };
                        }
                    });

                    return updatedSteps;
                });

                // If currentStep is provided, calculate next active step
                if (currentStep !== undefined) {
                    let nextStep = currentStep + 1;
                    while (nextStep <= 8) {
                        if (isStepDisabled(nextStep, data.step_status)) {
                            nextStep++;
                        } else {
                            break;
                        }
                    }
                    return nextStep <= 8 ? nextStep : null;
                }
            }
            return data;
        } catch (error) {
            // tslint:disable-next-line:no-console
            console.error("Error fetching step status:", error);
            return null;
        }
    };

    const checkData = async () => {
        const marineUse = await hasMarineData();
        setActiveStep(marineUse ? parseInt(marineUse.last_active_step) > 0 ? parseInt(marineUse.last_active_step) : 1 : 1);
        setIsJointActive(marineUse ? marineUse.joint_fulfillment : false);
        setIsReqByCustomerActive(marineUse ? marineUse.req_by_customer : false);
        setIsOutJointActive(marineUse ? marineUse.out_joint_fulfillment : false);
        setIsNotApplicableStepActive(marineUse ? marineUse.not_applicable_step : false);
        setIsAboveMandateAfterFulfillActive(marineUse ? marineUse.above_mandate_after_fulfill_step_active : false);
        setPercentageMarineGeneral(marineUse ? marineUse.general_mandate : false);
        if (marineUse) {
            getStepStatus();
        }
    };

    const fetchBiotemplateData = async () => {
        const response = await startAllocation("marine");
        if (response && response.valid) {
            setGeneralBiotemplates(response.offroad_biotemplates && response.offroad_biotemplates.general || []);
            setReservedBiotemplates(response.offroad_biotemplates && response.offroad_biotemplates.reserved || []);
            setStepJointFulfBiotemplates(response.offroad_biotemplates && response.offroad_biotemplates.joint || []);
            setAdditionalBiotemplates(response.offroad_biotemplates && response.offroad_biotemplates.additional || []);
            setNotApplicableBiotemplates(response.offroad_biotemplates && response.offroad_biotemplates.notApplicable || []);
            setGeneralAllocationNotNeeded(response.offroad_biotemplates && response.offroad_biotemplates.generalAllocationNotNeeded || false );

            const availableData = {};
            // @ts-ignore
            response.biotemplates.forEach((item: Biotemplate) => {
                // @ts-ignore
                availableData[item.biotemplate_id] = item.available_quantity;
            });
        } else {
            alert("Some error occured");
        }
    };

    useEffect(() => {
        setIsFetching(true);
        checkData();
        fetchBiotemplateData();
        setIsFetching(false);
    }, []);

    useEffect(() => {
        setSteps(prevSteps => ({
            ...prevSteps,
            2: {
                ...prevSteps[2],
                isDisabled: !isReqByCustomerActive,
            },
        }));
    }, [isReqByCustomerActive]);
    useEffect(() => {
        setSteps(prevSteps => ({
            ...prevSteps,
            3: {
                ...prevSteps[3],
                isDisabled: !isOutJointActive,
            },
        }));
        if (!isOutJointActive) {
            setStepJointFulfBiotemplates([]);
        }
    }, [isOutJointActive]);
    useEffect(() => {
        setSteps(prevSteps => ({
            ...prevSteps,
            4: {
                ...prevSteps[4],
                isDisabled: !isAboveMandateAfterFulfillActive,
            },
        }));
    }, [isAboveMandateAfterFulfillActive]);
    useEffect(() => {
        setSteps(prevSteps => ({
            ...prevSteps,
            5: {
                ...prevSteps[5],
                isDisabled: !isNotApplicableStepActive,
            },
        }));
    }, [isNotApplicableStepActive]);
    return (
        <>
            <div className={clsx(classes.root)}>
                <div className={classes.textContainer}>
                    <Typography variant="h6">
                        Allocation Mode:
                        <span className={classes.textPrimary}>{isSimulation ? "Simulation" : "Reporting"}</span>
                    </Typography>
                </div>
                <div className={classes.textContainer}>
                    <Typography variant="h6">
                        Mandate:
                        <span className={classes.textPrimary}>Marine</span>
                    </Typography>
                </div>
                <div className={classes.textContainer}>
                    <Typography variant="h6">
                        Period:
                        <span className={classes.textPrimary}>{periodName ? periodName.year : ""}</span>
                    </Typography>
                </div>
                <div className={classes.textContainer}>
                    <Typography variant="h6">
                        Fulfillment Type:
                        <span className={classes.textPrimary}>{isJointActive ? "Joint" : "Own"}</span>
                    </Typography>
                </div>
            </div>
            <Stepper
                alternativeLabel
                nonLinear
                activeStep={activeStep-1}
                connector={<StepConnector />}
                className={classes.stepper}
            >
                {Object.keys(steps).map((rank, index) => (
                    <Step key={index}>
                        <StepButton
                            onClick={() => console.log(activeStep)}
                            disabled={steps[rank].isDisabled}
                        >
                            <StepLabel
                                StepIconComponent={props => (
                                    <StepIcon
                                        disabled={steps[rank].isDisabled}
                                        status={steps[rank].isDisabled ? null : steps[rank].status}
                                        {...props}
                                    ></StepIcon>
                                )}
                            >
                                {steps[rank].name}
                            </StepLabel>
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            { isFetching ? (
                <LoadingView text={"Data is getting prepared"} />
            ) : (
                <>
                    <MarineCardEditableTable
                        step={activeStep}
                        reqByCustomerDisabled={!isReqByCustomerActive}
                        outJointDisabled={!isOutJointActive}
                        aboveMandateAfterFulfillDisabled={!isAboveMandateAfterFulfillActive}
                        notApplicableStepDisabled={!isNotApplicableStepActive}
                        handleNext={async () => {
                            setIsFetching(true);
                            if (activeStep && activeStep > 0 && activeStep < 8) {
                                const nextStep = await getStepStatus(activeStep);
                                if (nextStep) {
                                    setActiveStep(nextStep);
                                    fetchBiotemplateData();
                                }
                            }
                            setIsFetching(false);
                        }}
                        handleBack={async () => {
                            if (activeStep > 1) {
                                setActiveStep(activeStep - 1);
                                if (activeStep < 7) {
                                    fetchBiotemplateData();
                                }
                            }}}
                        updateIsFetching={updateIsFetching}
                        marineGeneralPercentage={percentageMarineGeneral}
                        generalBiotemplates={generalBiotemplates}
                        reservedBiotemplates={reservedBiotemplates}
                        jointFulfBiotemplates={stepJointFulfBiotemplates}
                        additionalBiotemplates={additionalBiotemplates}
                        notApplicableBiotemplates={notApplicableBiotemplates}
                        generalAllocationNotNeeded={generalAllocationNotNeeded}
                    />
                </>
            )}
        </>
    );
};

export default MarineContainer;
